import { ChangeEvent, FC, useEffect, useState } from "react";
import EditInputField from "../edit-input-field/EditInputField";
import { useAppDispatch, useAppSelector } from "../../../hooks/ReduxHooks";
import {
  createOrganization,
  createUser,
  getAllOrganizations,
} from "../../../redux/requests/AdminRequests";

interface IAddOrganizationModalProps {
  isActive: boolean;
  setIsActive: Function;
  ref: any;
}

const AddOrganizationModal: FC<IAddOrganizationModalProps> = ({
  isActive,
  ref,
  setIsActive,
}) => {
  const dispatch = useAppDispatch();
  const organizations = useAppSelector((state) => state.admin.organizations);
  const operator = useAppSelector((state) => state.user.operator);

  useEffect(() => {
    dispatch(getAllOrganizations());
  }, []);

  const [name, setName] = useState<string>("");

  const onAddOrganizationClick = () => {
    if (!name.trim()) return;

    if (!operator) return;

    dispatch(
      createOrganization({
        created_by: operator.id,
        name: name,
      })
    ).then((data) => {
      if (!data) return;
      setIsActive(false);
    });
  };

  return (
    <div
      tabIndex={-1}
      className={`${
        isActive ? "" : "hidden"
      } overflow-y-auto overflow-x-hidden absolute z-50 items-center md:inset-0 h-full w-full flex justify-center align-middle`}
    >
      <div
        className="relative p-4 w-full max-w-md max-h-full bg-white"
        ref={ref}
      >
        <div className="relative bg-neutral-primary-soft border border-default rounded-base shadow-sm p-4 md:p-6">
          <div className="flex items-center justify-between border-b border-default pb-4 md:pb-5">
            <h3 className="text-lg font-medium text-heading">
              Добавление организации
            </h3>
            <button
              type="button"
              className="text-body bg-transparent hover:bg-neutral-tertiary hover:text-heading rounded-base text-sm w-9 h-9 ms-auto inline-flex justify-center items-center"
              onClick={() => setIsActive(false)}
            >
              <svg
                className="w-5 h-5"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18 17.94 6M18 18 6.06 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>
          <div className="pt-4 md:pt-6">
            <EditInputField
              data={{
                id: 55,
                labelText: "name",
                type: "text",
                value: name,
              }}
              setValue={setName}
              readonly={false}
            />
          </div>
          <button
            className="text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none w-full mt-4"
            onClick={onAddOrganizationClick}
          >
            Добавить
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddOrganizationModal;
